export const PRODUCT_TEMPLATES_FILTERS = {
  STATUS_FILTER_DROPDOWN_TEST_ID: 'product-templates-status-filter-dropdown',
  PRODUCT_LINE_FILTER_DROPDOWN_TEST_ID: 'product-templates-product-line-filter-dropdown',
  STATE_FILTER_DROPDOWN_TEST_ID: 'product-templates-state-filter-dropdown',
  EFFECTIVE_YEAR_FILTER_DROPDOWN_TEST_ID: 'product-templates-effective-year-filter-dropdown',
};

export const PRODUCT_TEMPLATES_TABLE_TEST_ID = 'product-templates-table';
export const PRODUCT_TEMPLATES_TABLE_HEADER_TEST_ID = 'product-templates-table-header';
export const PRODUCT_TEMPLATES_TABLE_ROW_TEST_ID = 'product-templates-table-row';
export const PRODUCT_TEMPLATES_ADD_PRODUCT_BTN_TEST_ID = 'product-templates-add-product-btn';
export const PRODUCT_TEMPLATES_UPLOAD_JSON_BTN_TEST_ID = 'product-templates-upload-json-btn';

// Status filter card
export const PRODUCT_TEMPLATES_READY_STATUS_CARD_TEST_ID = 'product-templates-ready-status-card';
export const PRODUCT_TEMPLATES_ARCHIVE_STATUS_CARD_TEST_ID = 'product-templates-archive-status-card';
export const PRODUCT_TEMPLATES_IN_PROGRESS_STATUS_CARD_TEST_ID = 'product-templates-in-progress-status-card';
export const PRODUCT_TEMPLATES_INITIAL_SEED_STATUS_CARD_TEST_ID = 'product-templates-initial-seed-status-card';
export const PRODUCT_TEMPLATES_IM_GENERATED_STATUS_CARD_TEST_ID = 'product-templates-initial-im-generated-card';

// Dropdown options
export const PRODUCT_TEMPLATES_ROW_DROPDOWN_BTN_TEST_ID = 'product-templates-row-dropdown';
export const PRODUCT_TEMPLATES_ROW_DROPDOWN_EDIT_TEST_ID = 'product-templates-row-dropdown-edit';
export const PRODUCT_TEMPLATES_ROW_DROPDOWN_DUPLICATE_TEST_ID = 'product-templates-row-dropdown-duplicate';
export const PRODUCT_TEMPLATES_ROW_DROPDOWN_ARCHIVE_TEST_ID = 'product-templates-row-dropdown-archive';
export const PRODUCT_TEMPLATES_ROW_DROPDOWN_UNARCHIVE_TEST_ID = 'product-templates-row-dropdown-unarchive';
export const PRODUCT_TEMPLATES_ROW_DROPDOWN_DOWNLOAD_PDF_TEST_ID = 'product-templates-row-dropdown-download-pdf';
export const PRODUCT_TEMPLATES_ROW_DROPDOWN_DOWNLOAD_TEMPLATE_TEST_ID =
  'product-templates-row-dropdown-download-template';
export const PRODUCT_TEMPLATES_ROW_DROPDOWN_FULL_INFO_TEST_ID = 'product-templates-row-dropdown-full-info';

// Modals
export const PRODUCT_TEMPLATES_DUPLICATE_MODAL_TEST_ID = 'product-templates-duplicate-modal';
export const PRODUCT_TEMPLATES_DUPLICATE_MODAL_INT_NAME_INPUT_TEST_ID =
  'product-templates-duplicate-modal-int-name-input';
export const PRODUCT_TEMPLATES_DUPLICATE_MODAL_EXT_NAME_INPUT_TEST_ID =
  'product-templates-duplicate-modal-ext-name-input';
export const PRODUCT_TEMPLATES_INFO_MODAL_TEST_ID = 'product-templates-info-modal';
export const PRODUCT_TEMPLATES_INFO_MODAL_TABLE_TEST_ID = 'product-templates-info-modal-table';
export const PRODUCT_TEMPLATES_ARCHIVE_MODAL_TEST_ID = 'product-templates-archive-modal';
export const PRODUCT_TEMPLATES_UNARCHIVE_MODAL_TEST_ID = 'product-templates-unarchive-modal';

export const PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_ID = 'product-templates-add-product-modal-id';
export const PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_TEST_ID = 'product-templates-add-product-modal';
export const PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_INTERNAL_NAME_INPUT_TEST_ID =
  'product-templates-add-product-modal-internal-name-input';
export const PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_EXTERNAL_NAME_INPUT_TEST_ID =
  'product-templates-add-product-modal-external-name-input';
export const PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_PRODUCT_LINE_SELECT_TEST_ID =
  'product-templates-add-product-modal-product-line-select';
export const PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_STATE_SELECT_TEST_ID =
  'product-templates-add-product-modal-state-select';
export const PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_EFFECTIVE_FROM_INPUT_TEST_ID =
  'product-templates-add-product-modal-effective-from-input';
export const PRODUCT_TEMPLATES_ADD_PRODUCT_MODAL_EFFECTIVE_TO_INPUT_TEST_ID =
  'product-templates-add-product-modal-effective-to-input';
